import { createAsyncThunk } from '@reduxjs/toolkit';

import pushEvent, { SELECT_TRADE_IN_MAX_PRICE } from 'pushEvent/index';

import { api } from '../../../../api';

type FetchMaxPriceParams = {
  deviceType: string;
  brand: string;
  model: string;
  capacity: string;
};

export const fetchTradeInMaxPrice = createAsyncThunk(
  'tradeId/fetchMaxPrice',
  async ({ deviceType, brand, model, capacity }: FetchMaxPriceParams): Promise<number> => {
    const result = await api.fetchMaxPrice(deviceType, brand, model, capacity);

    pushEvent(SELECT_TRADE_IN_MAX_PRICE, { result: result.data.maxPrice });

    return result?.data?.maxPrice;
  },
);
